{
 "_meta": {
  "locale": "pl",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "Teraz",
  "people": "Osoby",
  "cases": "Sprawy",
  "agenda": "Terminarz",
  "reviews": "Przeglądy",
  "prospects": "Pozyskiwanie",
  "insights": "Analizy",
  "data": "Dane i bezpieczeństwo",
  "settings": "Ustawienia",
  "lens": "Lupa"
 },
 "common": {
  "save": "Zapisz",
  "cancel": "Anuluj",
  "close": "Zamknij",
  "search": "Szukaj",
  "today": "Dziś",
  "tomorrow": "Jutro",
  "new": "Nowy",
  "edit": "Edytuj",
  "delete": "Usuń"
 },
 "settings": {
  "title": "Ustawienia",
  "language": "Język",
  "region": "Rynek / region",
  "theme": "Wygląd"
 },
 "people": {
  "title": "Osoby",
  "new": "Nowa osoba"
 },
 "today": {
  "agenda_title": "Dziś"
 },
 "lens": {
  "placeholder": "Szukaj osób, potencjalnych klientów, spraw — lub wpisz polecenie"
 }
}